"use strict";

import React from "react";
import { ProjectStatus } from "./Index.jsx"; //DragAndDrop.jsx';
import FilterStatus from "./components/FilterStatus.jsx";

import request from "superagent";

import Translations from "../app/utils/translations.js";
let translations = new Translations([
  require("./portfolio/labels/english.js"),
  require("./portfolio/labels/norwegian.js"),
]);

class PortfolioOverview extends React.Component {
  includedInFilter(filter, portfolio) {
    let userEmailDomain =
      this.props.user !== undefined
        ? this.props.user.email.split("@").slice(-1)[0]
        : undefined;
    let included =
      filter === undefined ||
      (filter !== undefined && filter["portfolio_" + portfolio.id] !== false);
    let accessControl =
      portfolio.accessControl === undefined ||
      portfolio.accessControl === null ||
      portfolio.accessControl.includes(userEmailDomain);
    return included && accessControl;
  }

  render() {
    let labels = translations.getTranslation(this.props);
    var rowStyle = {
      display: "table-cell",
      borderBottom: "1px solid #ddd",
      padding: 8,
      textAlign: "left",
    };
    let projects = this.props.projects !== undefined ? this.props.projects : [];
    var withoutPortfolio = projects.filter(
      (project) =>
        project.portfolio === undefined ||
        project.portfolio === "" ||
        (this.props.tenant !== undefined &&
          this.props.tenant.portfolios.filter(
            (portfolio) => portfolio.id === project.portfolio,
          ).length === 0),
    ).length;
    return (
      <div>
        <FilterStatus {...this.props} />
        <table
          style={{
            width: "80%",
            lineHeight: "20px",
            borderCollapse: "collapse",
            borderSpacing: 0,
            marginLeft: "10%",
            marginRight: "10%",
            marginTop: 50,
            fontFamily: "Lato, Arial, 'Helvetica Neue', Helvetica, sans-serif",
            fontSize: "14px",
          }}
        >
          <thead>
            <tr style={{ fontSize: "16px" }}>
              <th style={rowStyle}>{labels.columns.portfolio}</th>
              <th style={rowStyle}>{labels.columns.numberOfProjects}</th>
            </tr>
          </thead>
          <tbody>
            {this.props.tenant.portfolios
              .filter((portfolio) =>
                this.includedInFilter(this.props.filter, portfolio),
              )
              .map((portfolio) => (
                <tr style={{ fontSize: "14px" }} key={portfolio.id}>
                  <td style={rowStyle}>
                    <a href={"/portfolio/" + portfolio.id + "/"}>
                      {portfolio.name}
                    </a>
                  </td>
                  <td style={rowStyle}>
                    {
                      projects.filter(
                        (project) =>
                          project.portfolio === portfolio.id &&
                          project.isStarted === true,
                      ).length
                    }
                  </td>
                </tr>
              ))}
            {withoutPortfolio > 0 ? (
              <tr>
                <td style={rowStyle}>
                  <a href={"/portfolio/other/"}>
                    {labels.general.otherPortfolio}
                  </a>
                </td>
                <td style={rowStyle}>{withoutPortfolio}</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    );
  }
}

class Details extends React.Component {
  render() {
    return this.props.tenant.portfolios !== undefined &&
      this.props.tenant.portfolios.length > 0 ? (
      <PortfolioOverview {...this.props} />
    ) : (
      <ProjectStatus tenant={this.props.tenant} />
    );
  }
}

export default class Portfolio extends React.Component {
  constructor(props) {
    super(props);
    var filter =
      this.props.user !== undefined &&
      this.props.user.filters !== undefined &&
      this.props.tenant !== undefined
        ? this.props.user.filters[this.props.tenant.id]
        : undefined;
    var projects =
      this.props.projects !== undefined
        ? this.props.projects
        : this.props.tenant !== undefined
        ? this.props.tenant.projects
        : undefined;
    this.state = {
      projects:
        filter !== undefined && projects !== undefined
          ? projects.filter((project) => this.includedInFilter(filter, project))
          : projects,
      excludedProjects:
        filter !== undefined && projects !== undefined
          ? projects.filter(
              (project) => !this.includedInFilter(filter, project),
            )
          : [],
      filter: filter,
    };
  }

  prioritizeProject(priorization) {
    var projects = this.state.projects;
    let url =
      this.props.programOverview === true
        ? "/programmes/" +
          this.props.programme.id +
          "/prioritize" +
          (this.props.programme.useTenantPriority ? "?tenantPriority=true" : "")
        : "/prioritize" +
          (this.props.combinedPriority === false
            ? "?combinedPriority=false"
            : "");

    request
      .post(url)
      .send(priorization)
      .end(
        function (err, response) {
          if (err === null) {
            var prioritizedProjects = JSON.parse(response.text);
            var updatedProjects = prioritizedProjects
              .map(function (project) {
                var foundProject = projects.filter(
                  (existingProject) => existingProject.id === project.id,
                )[0];
                return Object.assign({}, foundProject, {
                  priority: project.priority,
                });
              })
              .filter((project) => project.id !== undefined);
            this.setState({ projects: updatedProjects });
          }
        }.bind(this),
      );
  }

  includedInFilter(filter, project) {
    var included = true;
    [
      "portfolio",
      "projectType",
      "category",
      "department",
      "state",
      "location",
      "phase",
    ].forEach((property) => {
      var encodedKey =
        property +
        "_" +
        (property === "phase"
          ? Buffer.from(project[property]).toString("base64")
          : project[property]);
      return (included =
        included &&
        (project[property] === undefined || filter[encodedKey] !== false));
    });
    return included;
  }

  render() {
    var filter = this.state.filter;
    var projects = this.state.projects;
    return this.props.programOverview !== true &&
      this.props.tenant !== undefined &&
      this.props.tenant.portfolios !== undefined &&
      this.props.tenant.portfolios.length > 0 &&
      this.props.portfolio === undefined ? (
      <PortfolioOverview
        {...this.props}
        projects={projects}
        filter={filter}
        excludedProjects={this.state.excludedProjects}
      />
    ) : (
      <ProjectStatus
        {...this.props}
        tenant={
          this.props.design !== undefined && this.props.tenant === undefined
            ? Object.assign({}, this.props.tenant, {
                design: this.props.design,
              })
            : this.props.tenant
        }
        projects={projects}
        prioritize={this.prioritizeProject.bind(this)}
        filter={filter}
        portfolio={this.props.portfolio}
        excludedProjects={this.state.excludedProjects}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./views/Portfolio.jsx